import { IMenuList } from "../routers/interface";

export const menusListDefault: Array<IMenuList> = [
  {
    label: "menu.dashboard",
    rolesToShow: [""],
    show: true,
    location: "dashboard",
    index: 0,
    route: "/dashboard",
    locationNumber: 0,
  },
  {
    label: "menu.audiences",
    rolesToShow: ["Administrador", "Operador"],
    show: true,
    location: "audiences",
    index: 1,
    route: "/audiences",
    locationNumber: 0,
  },
  {
    label: "menu.administration",
    rolesToShow: ["Master", "Administrador"],
    show: true,
    location: "administration",
    index: 2,
    route: "/administration",
    locationNumber: 0,
  },
  {
    label: "menu.reports",
    rolesToShow: ["Master", "Operador", "Administrador"],
    location: "report",
    show: true,
    index: 3,
    route: "/report",
    locationNumber: 2,
  },
];
